import React from "react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  prod1,
  prod2,
  prod3,
  prod4,
  prod5,
  prod6,
  prod7,
  prod8,
} from "constants/Images";

export default function Products({ trans }) {
  return (
    <div
      id="products"
      className="container mt-5 pt-5 px-lg-4 px-md-0 px-5 position-relative"
    >
      <div className="d-flex justify-content-center w-100 ">
        <h2>{trans("products", { ns: "navbar" })}</h2>
      </div>
      <div className="d-flex justify-content-end gap-2 mb-4 ">
        <div
          className=" bg-main px-3 rounded-3 prev-btn-swiper
      "
        >
          <i class="fa-solid fa-chevron-left text-white"></i>
        </div>
        <div
          className=" bg-main px-3 rounded-3 next-btn-swiper
      "
        >
          <i class="fa-solid fa-chevron-right text-white"></i>
        </div>
      </div>

      <div className="row overflow-hidden w-100">
        <Swiper
          modules={[Navigation]}
          navigation={{
            nextEl: ".next-btn-swiper",
            prevEl: ".prev-btn-swiper ",
          }}
          slidesPerView={1.1}
          spaceBetween={10}
          breakpoints={{
            646: {
              slidesPerView: 2,
            },
            1036: {
              slidesPerView: 3,
            },
            1203: {
              slidesPerView: 4,
            },
          }}
          className="swiper  w-100 "
        >
          <>
            <SwiperSlide className="">
              {/* <div className="row"> */}
              {/* <div className="col-12 ps-0"> */}
              <div class="card-1 rounded-3">
                <img className="prodImg bg-info" alt={prod1} src={prod1} />
                <h5 class="card-title text-center  mt-3  ">Pluto G4</h5>
              </div>

              {/* </div> */}
              {/* </div> */}

              {/* </div> */}
            </SwiperSlide>

            <SwiperSlide className="">
              <div className="row">
                <div className="col-12">
                  <div class="card-1 rounded-3  ">
                    <img className="prodImg bg-info" alt={prod2} src={prod2} />
                    <h5 class="card-title text-center  mt-3  mx-auto ">
                      SKY G5
                    </h5>
                  </div>
                </div>
              </div>

              {/* </div> */}
            </SwiperSlide>

            <SwiperSlide className="">
              <div className="row">
                <div className="col-12">
                  <div class="card-1 rounded-3  ">
                    <img className="prodImg bg-info" alt={prod3} src={prod3} />
                    <h5 class="card-title text-center  mt-3  ">
                      Interior Filler
                    </h5>
                  </div>
                </div>
              </div>

              {/* </div> */}
            </SwiperSlide>

            <SwiperSlide className="">
              <div className="row">
                <div className="col-12">
                  <div class="card-1 rounded-3  ">
                    <img className="prodImg bg-info" alt={prod4} src={prod4} />
                    <h5 class="card-title text-center  mt-3  ">Rocket G10</h5>
                  </div>
                </div>
              </div>

              {/* </div> */}
            </SwiperSlide>

            <SwiperSlide className="">
              <div className="row">
                <div className="col-12">
                  <div class="card-1 rounded-3  ">
                    <img className="prodImg bg-info" alt={prod5} src={prod5} />
                    <h5 class="card-title text-center  mt-3  ">
                      Enternal Putty Star g1000
                    </h5>
                  </div>
                </div>
              </div>

              {/* </div> */}
            </SwiperSlide>

            <SwiperSlide className="">
              <div className="row">
                <div className="col-12">
                  <div class="card-1 rounded-3  ">
                    <img className="prodImg bg-info" alt={prod6} src={prod6} />
                    <h5 class="card-title text-center  mt-3  ">
                      External Putty Star g1200
                    </h5>
                  </div>
                </div>
              </div>

              {/* </div> */}
            </SwiperSlide>

            <SwiperSlide className="">
              <div className="row">
                <div className="col-12">
                  <div class="card-1 rounded-3  ">
                    <img className="prodImg bg-info" alt={prod7} src={prod7} />
                    <h5 class="card-title text-center  mt-3  ">
                      Exterior Filler
                    </h5>
                  </div>
                </div>
              </div>

              {/* </div> */}
            </SwiperSlide>

            <SwiperSlide className="">
              <div className="row">
                <div className="col-12">
                  <div class="card-1 rounded-3  ">
                    <img className="prodImg bg-info" alt={prod8} src={prod8} />
                    <h5 class="card-title text-center  mt-3  ">
                      GS 2030 PLASTIC ECONOMIC
                    </h5>
                  </div>
                </div>
              </div>

              {/* </div> */}
            </SwiperSlide>
          </>
        </Swiper>
      </div>
    </div>
  );
}
